import { useQuery } from "@tanstack/react-query";
import { SystemInputs } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import i18n from "i18n";
import { onError } from "util/conditional/onError";
export const INPUT_REFERENCES = "streams_by_index_set_id";
const DEFAULT_DATA = {
  stream_refs: [],
  pipeline_refs: []
};
const fetchInputReferences = async (inputId) => SystemInputs.getReferences(inputId);
const useInputReferences = (inputId) => {
  var _a, _b;
  const { data, isLoading } = useQuery({
    queryKey: [INPUT_REFERENCES],
    queryFn: () => onError(fetchInputReferences(inputId), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(
          i18n.t("setup_wizard.load_input_references_failed", { ns: "inputs", error: errorThrown })
        );
      }
    }),
    enabled: !!inputId
  });
  const inputReferencesData = data != null ? data : DEFAULT_DATA;
  const isInputAlreadyInUse = ((_a = inputReferencesData == null ? void 0 : inputReferencesData.stream_refs) == null ? void 0 : _a.length) > 0 || ((_b = inputReferencesData == null ? void 0 : inputReferencesData.pipeline_refs) == null ? void 0 : _b.length) > 0;
  return {
    data: {
      isInputAlreadyInUse,
      stream_refs: inputReferencesData.stream_refs,
      pipeline_refs: inputReferencesData.pipeline_refs
    },
    isLoading
  };
};
export default useInputReferences;
